import moment from "moment";
export default () => ({
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),

    orders: null,
    ordersConfig: {
        include: "",
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        filters: '',
        per_page: 100,
    },
});
